import WaveSurfer from 'wavesurfer.js';
import PageHandlersService from '@/utils/page-handlers-service';

interface ITextReviewItemData {
    name: string;
    date: string;
    content: string;
    productTags: string[];
    city: string;
}

const pageHandlers = new PageHandlersService();

export let homePagePlayingPlayer: any = null;

export const formatPlayerTime = (seconds: number) => {
    return `${`${Math.floor(seconds / 60)}`.padStart(2, '0')}:${`${Math.floor(seconds % 60)}`.padStart(2, '0')}`;
};

const init = () => {
    const textReviewsButton = document.querySelector<HTMLElement>('.js-main-text-reviews-btn');
    const audioReviewsButton = document.querySelector<HTMLElement>('.js-main-audio-reviews-btn');
    const instagramReviewsButtons = Array.from(
        document.querySelectorAll<HTMLElement>('.js-main-instagram-reviews-btn'),
    );
    const textReviewsPopup = document.querySelector<HTMLElement>('.js-text-reviews-popup');
    const audioReviewsPopup = document.querySelector<HTMLElement>('.js-audio-reviews-popup');
    const instagramReviewsPopups = Array.from(document.querySelectorAll<HTMLElement>('.js-instagram-reviews-popup'));
    const closeButtons = document.querySelectorAll<HTMLElement>('.js-reviews-popup-close');
    const reviewsListItems = document.querySelectorAll<HTMLElement>('.js-review-list-item');

    // Открытие / закрытие попапов
    let removeBodyNoScrollTimeout: NodeJS.Timeout;

    const handleClosePopups = () => {
        [textReviewsPopup, audioReviewsPopup, ...instagramReviewsPopups].forEach((popup) => {
            if (popup) {
                popup.classList.remove('active');
                popup.classList.remove('synchronized');
            }
        });

        removeBodyNoScrollTimeout = setTimeout(() => {
            document.body.classList.remove('no-scroll');
        }, 400);

        if (homePagePlayingPlayer && playingPlayerContainer) {
            homePagePlayingPlayer.pause();
            playingPlayerContainer.classList.remove('playing');

            homePagePlayingPlayer = null;
        }
    };

    pageHandlers.set(textReviewsButton, (event) => {
        event.stopPropagation();
        textReviewsPopup?.classList.add('active');

        if (audioReviewsPopup) {
            audioReviewsPopup.classList.add('synchronized');
            audioReviewsPopup.classList.remove('active');
        }

        instagramReviewsPopups.forEach((popup) => {
            popup.classList.add('synchronized');
            popup.classList.remove('active');
        });

        if (removeBodyNoScrollTimeout) {
            clearTimeout(removeBodyNoScrollTimeout);
        }

        document.body.classList.add('no-scroll');
    });

    instagramReviewsButtons.forEach((btn) => {
        pageHandlers.set(btn, (event) => {
            event.stopPropagation();

            instagramReviewsPopups.forEach((popup) => {
                if (popup.dataset.instagramReviewId === btn.dataset.instagramReviewId) {
                    popup.classList.add('active');
                } else {
                    popup.classList.add('synchronized');
                    popup.classList.remove('active');
                }
            });

            if (textReviewsPopup) {
                textReviewsPopup.classList.add('synchronized');
                textReviewsPopup.classList.remove('active');
            }

            if (audioReviewsPopup) {
                audioReviewsPopup.classList.add('synchronized');
                audioReviewsPopup.classList.remove('active');
            }

            if (removeBodyNoScrollTimeout) {
                clearTimeout(removeBodyNoScrollTimeout);
            }

            document.body.classList.add('no-scroll');
        });
    });

    pageHandlers.set(audioReviewsButton, (event) => {
        event.stopPropagation();
        audioReviewsPopup?.classList.add('active');

        if (textReviewsPopup) {
            textReviewsPopup.classList.add('synchronized');
            textReviewsPopup.classList.remove('active');
        }

        instagramReviewsPopups.forEach((popup) => {
            popup.classList.add('synchronized');
            popup.classList.remove('active');
        });

        if (removeBodyNoScrollTimeout) {
            clearTimeout(removeBodyNoScrollTimeout);
        }

        document.body.classList.add('no-scroll');
    });

    const stopPropagation = (event: Event) => event.stopPropagation();

    pageHandlers.set(textReviewsPopup, stopPropagation);
    pageHandlers.set(audioReviewsPopup, stopPropagation);
    instagramReviewsPopups.forEach((popup) => {
        pageHandlers.set(popup, stopPropagation);
    });

    pageHandlers.set(document, handleClosePopups);

    closeButtons.forEach((button) => {
        pageHandlers.set(button, handleClosePopups);
    });

    // Текстовые попапы
    const textDetailReviewBackBtn = document.querySelector('.js-text-detail-review-back-btn');

    pageHandlers.set(textDetailReviewBackBtn, () => {
        if (textReviewsPopup) {
            textReviewsPopup.classList.add('active-list');
        }
    });

    const textDetailReviewDate = document.querySelector<HTMLElement>('.js-text-detail-review-date');
    const textDetailReviewProductTags = document.querySelector<HTMLElement>('.js-text-detail-review-product-tags');
    const textDetailReviewName = document.querySelector<HTMLElement>('.js-text-detail-review-name');
    const textDetailReviewContent = document.querySelector<HTMLElement>('.js-text-detail-review-content');

    reviewsListItems.forEach((item) => {
        const itemDataElement = item.querySelector<HTMLElement>('.js-text-review-item-data');
        const readMoreBtn = item.querySelector('.js-text-review-read-more');

        if (itemDataElement && textReviewsPopup) {
            const itemData: ITextReviewItemData = {
                name: itemDataElement.querySelector('.js-name')?.innerHTML ?? '',
                date: itemDataElement.querySelector('.js-date')?.innerHTML ?? '',
                content: itemDataElement.querySelector('.js-content')?.innerHTML ?? '',
                productTags:
                    itemDataElement
                        .querySelector('.js-product-tags')
                        ?.innerHTML.split(',')
                        .map((tag) => tag.trim())
                        .filter((tag) => !!tag) ?? [],
                city: itemDataElement.querySelector('.js-city')?.innerHTML ?? '',
            };

            pageHandlers.set(readMoreBtn, () => {
                if (textDetailReviewDate) {
                    textDetailReviewDate.innerText = itemData.date;
                }

                if (textDetailReviewProductTags) {
                    const newTag = document.createElement('p');
                    newTag.className = 'text-detail-review__tag';
                    newTag.innerText = `#текстовый отзыв`;

                    itemData.productTags.forEach((tag) => {
                        const newTag = document.createElement('p');

                        const tagValue = tag.replaceAll('<br>', '');

                        newTag.className = 'text-detail-review__tag';
                        newTag.innerText = `#${tagValue}`;

                        textDetailReviewProductTags.appendChild(newTag);
                    });
                }

                if (textDetailReviewName) {
                    textDetailReviewName.innerText = itemData.name;
                }

                if (textDetailReviewContent) {
                    textDetailReviewContent.innerHTML = itemData.content;
                }

                textReviewsPopup.classList.remove('active-list');
            });
        }
    });

    // Аудио попапы
    const audioReviewItems = document.querySelectorAll('.js-audio-review-item');
    let playingPlayerContainer: Element | null = null;

    audioReviewItems.forEach((item) => {
        const timelineContainer = item.querySelector<HTMLElement>('.js-audio-review-item-timeline');
        const playButton = item.querySelector<HTMLButtonElement>('.js-audio-review-item-play');
        const currentTimeElement = item.querySelector<HTMLElement>('.js-audio-review-item-time-current');
        const durationTimeElement = item.querySelector<HTMLElement>('.js-audio-review-item-time-duration');

        if (
            timelineContainer &&
            timelineContainer.dataset.audiofileSrc &&
            playButton &&
            currentTimeElement &&
            durationTimeElement
        ) {
            const player = WaveSurfer.create({
                container: timelineContainer,
                waveColor: '#D1D1D1',
                progressColor: '#767676',
                barWidth: 2,
                barHeight: 1,
                height: 43 * 2,
                barGap: 1,
                cursorWidth: 0,
                mediaControls: true,
                hideScrollbar: true,
                normalize: true,
            });

            setTimeout(() => {
                player.load(timelineContainer.dataset.audiofileSrc);
            });

            pageHandlers.set(playButton, () => {
                player.playPause();
                item.classList.toggle('playing');

                if (player.isPlaying()) {
                    if (homePagePlayingPlayer && playingPlayerContainer) {
                        homePagePlayingPlayer.pause();
                        playingPlayerContainer.classList.remove('playing');
                    }

                    homePagePlayingPlayer = player;
                    playingPlayerContainer = item;
                } else {
                    homePagePlayingPlayer = null;
                }
            });

            pageHandlers.set(
                timelineContainer,
                () => {
                    setTimeout(() => {
                        currentTimeElement.innerText = formatPlayerTime(player.getCurrentTime());
                    }, 1);
                },
                'mouseup',
            );

            let isCurrentTimeSet = false;

            player.on('audioprocess', () => {
                if (!isCurrentTimeSet) {
                    isCurrentTimeSet = true;

                    currentTimeElement.innerText = formatPlayerTime(player.getCurrentTime());

                    setTimeout(() => {
                        isCurrentTimeSet = false;
                    }, 1000);
                }
            });

            player.on('ready', () => {
                durationTimeElement.innerText = formatPlayerTime(player.getDuration());
            });

            player.on('finish', () => {
                player.stop();
                item.classList.remove('playing');
                homePagePlayingPlayer = null;
            });
        }
    });
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
